module.exports = __webpack_public_path__ + "static/PHLivingroom-8e0b5664e94715b8b3c77b474dae4ecd.jpg";